// <EmptyState> is the placeholder for any M0 page that has no real content
// yet. M1 replaces it with the real component, but the spec mandates a
// consistent shape so the M0 skeleton reads uniformly.

import { createElement, type JSX, type ReactNode } from "react";

export interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
  /** Optional override of the root element (defaults to a <section>). */
  as?: keyof JSX.IntrinsicElements;
}

export function EmptyState({
  title,
  description,
  icon,
  action,
  as = "section",
}: EmptyStateProps): JSX.Element {
  return createElement(
    as,
    {
      "data-testid": "empty-state",
      className:
        "flex flex-col items-center justify-center gap-4 rounded-2xl border border-border bg-surface p-12 text-center shadow-sm",
    },
    icon ? <div className="text-fg-muted">{icon}</div> : null,
    <h2 className="text-2xl font-black text-fg">{title}</h2>,
    description ? (
      <p className="max-w-md text-sm text-fg-muted">{description}</p>
    ) : null,
    <p className="text-2xs uppercase tracking-widest text-fg-muted">
      Coming soon
    </p>,
    action ? <div className="mt-2">{action}</div> : null,
  );
}
